import { render, staticRenderFns } from "./InquiryContentsCardCorrespondenceInfo.vue?vue&type=template&id=6bd7aea7&scoped=true&"
import script from "./InquiryContentsCardCorrespondenceInfo.vue?vue&type=script&lang=js&"
export * from "./InquiryContentsCardCorrespondenceInfo.vue?vue&type=script&lang=js&"
import style0 from "./InquiryContentsCardCorrespondenceInfo.vue?vue&type=style&index=0&id=6bd7aea7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd7aea7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VContainer,VDivider,VRow,VSheet,VSpacer,VTextarea})
